import { render, staticRenderFns } from "./UpcomingEvents.vue?vue&type=template&id=1921c1ca&scoped=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"
import style0 from "./UpcomingEvents.vue?vue&type=style&index=0&id=1921c1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1921c1ca",
  null
  
)

export default component.exports